import { Title, Text } from "@mantine/core";

export function UsersPage() {
  return (
    <>
      <Title order={2} mb="md">
        Users
      </Title>
      <Text c="dimmed">User management and role assignments.</Text>
    </>
  );
}
